module.exports = __webpack_public_path__ + "img/56.44b9b769.png";